import { useState } from 'react';

export interface UseRequestPlusModalResult {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

export default function useRequestPlusModal(): UseRequestPlusModalResult {
  const [isOpen, setIsOpen] = useState(false);

  return {
    isOpen,
    open: () => setIsOpen(true),
    close: () => setIsOpen(false),
  };
}
